import React from 'react'

import { Flex, Text, SVG, Link } from 'system'
import { ReactComponent as AssetIconArrowLeftSVG } from '../assets/icon-arrow-left.svg'

import { FloatingCard } from './FloatingCard'

export const PrevNext = ({
  children,
  direction = 'next',
  group = '',
  label,
  href,
  ...props
}) => (
  <Link href={href} {...props}>
    <Flex
      alignItems="center"
      border="2px solid"
      borderColor="purple.90"
      borderRadius="8px"
      maxWidth="24rem"
      myScale="m"
      pScale="m"
    >
      <SVG
        x={1}
        y={1}
        svg={AssetIconArrowLeftSVG}
        fill="purple.50"
        width="1.75rem"
        order={direction === 'next' ? '1' : 0}
        className="arrow"
        css={`
          transform: ${direction === 'next' ? 'rotate(180deg)' : null};
        `}
      />
      <Text width={1} textAlign={direction === 'next' ? 'left' : 'right'}>
        <Text fontSizeScale="s" mbScale="t-">{`${group} – ${label}`}</Text>
        <Text color="black" fontWeight="semibold" fontSize="midMedium">
          {children}
        </Text>
      </Text>
    </Flex>
  </Link>
)
